export default __webpack_public_path__ + "90324e0eead65eba42c631b14463f8fb.png";